import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { toast } from '@components';

import { Text } from '@components/Styled';
import { useProfile } from '@lib/profile';

import Span from './CompleteProfileToast.style';

const CompleteProfileToast = () => {
  const { profile } = useProfile();
  const navigation = useNavigate();
  const location = useLocation();

  const [showCompleteProfileToast, setShowCompleteProfileToast] = useState(
    !profile.isDoneRegistering()
  );

  if (location.pathname.includes('marketplace') && showCompleteProfileToast) {
    toast.warning(
      <Text align="left">
        Para poder invertir necesitas tener tu perfil
        <br />
        completo y validado.
        {' '}
        <Span>Completa tu perfil</Span>
      </Text>,
      {
        time: 5000,
        iconName: 'icWarningWhite',
        iconAlt: 'warning',
        onClick: () => navigation('/enrollment')
      }
    );

    setShowCompleteProfileToast(false);
  }
};

export default CompleteProfileToast;
